module.exports = __webpack_public_path__ + "static/media/opt_pk_react_thumbnail.2bd4c59b.jpg";